// Main App JS File
"use strict";
console.log("Hurray, JS File Compiled");

// SMOOTH SCROLL
import SmoothScroll from "smooth-scroll";
const scroll = new SmoothScroll("a[href^='#']", {
  speed: 250,
  offset: 130,
  updateURL: false,
  popstate: false,
});

// SITE IMPORTS
import "./components/Header";
import "./components/Swiper";
import "./components/Modules";
import "./components/Gallery.js";
import "./components/Alerts.js";

// PARKING
import "./components/parking";
import "./components/flights";
import "./components/destinations";
